import './DesktopFilters.scss';
import React from 'react';
import { cn } from '../../../common/utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Button } from '@dataartdev/uikit/Button';
import { RadioGroup } from '@dataartdev/uikit/RadioGroup';
import { CheckboxGroup } from '@dataartdev/uikit/CheckboxGroup';
import { Combobox } from '@dataartdev/uikit/Combobox';
import { IDesctopFilter } from '../pages/blog_page_models';

export const cnDesktopFilters = cn('DesktopFilters');

export const DesktopFilters: React.FC<IDesctopFilter> = ({
  modesLabel,
  modes,
  modeSelected,
  modeChange,
  // tagsPlaceholder,
  tagsPlaceholderSelected,
  tags = [],
  // moreTags,
  // moreTagsButton,
  tagsSelected,
  tagsChange,
  industries = [],
  industriesPlaceholder,
  industriesSelected,
  industriesChange,
  industriesPlaceholderSelected,
  contentTypePlaceholder,
  contentTypes = [],
  contentTypesSelected,
  contentTypesChange,
  // contentTypesPlaceholderSelected,
  onResetForm,
  clearAllLabel = 'Clear All',
}) => {
  return (
    <div className={cnDesktopFilters()}>
      <div className={cnDesktopFilters('Segment')}>
        {modesLabel && (
          <Typography.Text
            className={cnDesktopFilters('SubTitle')}
            size="xs"
            weight="bold"
            transform="uppercase"
            as="h3"
          >
            {modesLabel}
          </Typography.Text>
        )}
        <RadioGroup
          value={modeSelected}
          items={modes}
          getLabel={item => item.title}
          getBadge={item => item.label}
          onChange={modeChange}
          direction="column"
        />
      </div>
      <div className={cnDesktopFilters('Segment')}>
        {industries?.length > 0 && (
          <Combobox
            multiple
            className={cnDesktopFilters('Select')}
            dropdownClassName="no-scroll"
            groupValues
            placeholder={industriesPlaceholder}
            placeholderSelected={industriesPlaceholderSelected}
            items={industries}
            value={industriesSelected}
            getItemLabel={item => item.title}
            onChange={industriesChange}
            view="outline"
          />
        )}
        {tags?.length > 0 && (
          <Combobox
            placeholder={tagsPlaceholderSelected}
            items={tags}
            value={tagsSelected}
            onChange={tagsChange}
            multiple
            className={cnDesktopFilters('Select')}
            placeholderSelected={tagsPlaceholderSelected}
            getItemLabel={item => item.title}
            view="outline"
          />
        )}
      </div>
      {contentTypes?.length > 0 && (
        <div className={cnDesktopFilters('Segment')}>
          <Typography.Text
            className={cnDesktopFilters('SubTitle')}
            size="xs"
            weight="bold"
            transform="uppercase"
            as="h3"
          >
            {contentTypePlaceholder}
          </Typography.Text>
          <CheckboxGroup
            direction="column"
            getLabel={item => item.title}
            getDisabled={item => item.disabled}
            onChange={contentTypesChange}
            items={contentTypes}
            value={contentTypesSelected}
          />
        </div>
      )}
      <div className={cnDesktopFilters('Segment')}>
        <Button
          view="primary"
          label={clearAllLabel}
          className={cnDesktopFilters('Clear-Button')}
          onClick={onResetForm}
        />
      </div>
    </div>
  );
};
